<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="920px" append-to-body>
    <template slot="title">
      <div class="doc-dialog-header">
        <span>{{ dialogTitle }}</span>
        <el-button-group v-if="showViewToolbar">
          <el-button v-if="isAuth('workflow:definition:update')" type="primary" size="small" :disabled="actionLoading" @click="editFromView">修改</el-button>
          <el-button v-if="isAuth('workflow:definition:delete')" type="primary" size="small" :disabled="actionLoading" @click="deleteHandle">删除</el-button>
        </el-button-group>
      </div>
    </template>
    <el-form ref="dataForm" :model="dataForm" :rules="formRules" label-width="100px">
      <el-row :gutter="12">
        <el-col :span="12">
          <el-form-item label="流程名称" prop="definitionName"><el-input v-model="dataForm.definitionName" :disabled="formReadonly" /></el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单据类型" prop="bizType">
            <el-select v-model="dataForm.bizType" :disabled="formReadonly" style="width:100%" @change="onBizTypeChange">
              <el-option v-for="o in bizTypeOptions" :key="o.value" :label="o.label" :value="o.value" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="12">
        <el-col :span="8">
          <el-form-item label="优先级">
            <el-input-number v-model="dataForm.priority" :disabled="formReadonly" :min="1" :max="999" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="启用">
            <el-switch v-model="dataForm.enabled" :disabled="formReadonly" active-value="1" inactive-value="0" />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="block-title">触发条件</div>
      <div v-if="!dataForm.bizType" class="muted">请先选择单据类型</div>
      <template v-else>
        <div v-if="formReadonly" class="summary">{{ conditionSummary }}</div>
        <template v-else>
          <el-form-item label="组合方式" label-width="100px" style="margin-bottom:8px;">
            <el-radio-group v-model="condition.logic" size="small">
              <el-radio label="and">满足全部</el-radio>
              <el-radio label="or">满足任一</el-radio>
            </el-radio-group>
            <span class="muted" style="margin-left:12px">不添加条件表示始终匹配；字段在「审批条件字段」中维护</span>
          </el-form-item>
          <el-table :data="condition.rules" border size="small" :header-cell-style="headStyle">
            <el-table-column type="index" label="序号" width="55" header-align="center" align="center" />
            <el-table-column label="字段" min-width="130" header-align="center">
              <template slot-scope="s">
                <el-select v-model="s.row.field" filterable size="mini" style="width:100%" placeholder="请选择字段" @change="onConditionFieldChange(s.row)">
                  <el-option v-for="f in conditionFieldOptions" :key="f.field" :label="f.label" :value="f.field" />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="比较" width="120" header-align="center">
              <template slot-scope="s">
                <el-select v-model="s.row.op" size="mini" style="width:100%" @change="onConditionOpChange(s.row)">
                  <el-option v-for="o in opsForRow(s.row)" :key="o.value" :label="o.label" :value="o.value" />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="值" min-width="180" header-align="center">
              <template slot-scope="s">
                <el-input-number v-if="fieldMeta(s.row.field).valueType === 'number'" v-model="s.row.value" size="mini" :controls="false" style="width:100%" />
                <el-select v-else-if="fieldMeta(s.row.field).valueType === 'dept' && s.row.op === 'in'" v-model="s.row.value" multiple filterable collapse-tags size="mini" style="width:100%">
                  <el-option v-for="d in deptOptions" :key="d.departId" :label="d.departName" :value="String(d.departId)" />
                </el-select>
                <el-select v-else-if="fieldMeta(s.row.field).valueType === 'dept'" v-model="s.row.value" filterable size="mini" style="width:100%">
                  <el-option v-for="d in deptOptions" :key="d.departId" :label="d.departName" :value="String(d.departId)" />
                </el-select>
                <el-select v-else-if="fieldMeta(s.row.field).valueType === 'user' && s.row.op === 'in'" v-model="s.row.value" multiple filterable collapse-tags size="mini" style="width:100%">
                  <el-option v-for="u in userOptions" :key="u.id" :label="u.name" :value="String(u.id)" />
                </el-select>
                <el-select v-else-if="fieldMeta(s.row.field).valueType === 'user'" v-model="s.row.value" filterable size="mini" style="width:100%">
                  <el-option v-for="u in userOptions" :key="u.id" :label="u.name" :value="String(u.id)" />
                </el-select>
                <el-input v-else v-model="s.row.value" size="mini" placeholder="请输入" />
              </template>
            </el-table-column>
            <el-table-column label="操作" width="70" header-align="center" align="center">
              <template slot-scope="s"><el-button type="text" size="mini" @click="condition.rules.splice(s.$index, 1)">删除</el-button></template>
            </el-table-column>
          </el-table>
          <el-button type="text" icon="el-icon-plus" :disabled="!conditionFieldOptions.length" @click="addCondition">添加条件</el-button>
          <span v-if="!conditionFieldOptions.length" class="warn">请先在「审批条件字段」中维护该单据类型的字段</span>
        </template>
      </template>
      <el-form-item label="备注" style="margin-top:8px;"><el-input v-model="dataForm.remark" :disabled="formReadonly" /></el-form-item>
      <div class="block-title">审批步骤</div>
      <el-table :data="dataForm.steps" border size="small" :header-cell-style="headStyle">
        <el-table-column type="index" label="序号" width="55" header-align="center" align="center" />
        <el-table-column label="步骤名称" min-width="120" header-align="center">
          <template slot-scope="s"><el-input v-model="s.row.stepName" :disabled="formReadonly" size="mini" placeholder="如：部门主管" /></template>
        </el-table-column>
        <el-table-column label="审批人类型" width="130" header-align="center">
          <template slot-scope="s">
            <el-select v-model="s.row.approverType" :disabled="formReadonly" size="mini" style="width:100%" @change="s.row.approverValue = ''">
              <el-option label="角色" value="role" />
              <el-option label="指定用户" value="user" />
              <el-option label="部门负责人" value="dept_leader" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="审批人/角色" min-width="160" header-align="center">
          <template slot-scope="s">
            <el-select v-if="s.row.approverType === 'role'" v-model="s.row.approverValue" :disabled="formReadonly" filterable size="mini" style="width:100%">
              <el-option v-for="r in roleOptions" :key="r.id" :label="r.name" :value="String(r.id)" />
              <el-option v-if="s.row.approverValue && !roleOptions.some(r => String(r.id) === s.row.approverValue)" :label="'失效角色（' + s.row.approverValue + '）'" :value="s.row.approverValue" disabled />
            </el-select>
            <el-select v-else-if="s.row.approverType === 'user'" v-model="s.row.approverValue" :disabled="formReadonly" filterable size="mini" style="width:100%">
              <el-option v-for="u in userOptions" :key="u.id" :label="u.name" :value="String(u.id)" />
              <el-option v-if="s.row.approverValue && !userOptions.some(u => String(u.id) === s.row.approverValue)" :label="'失效用户（' + s.row.approverValue + '）'" :value="s.row.approverValue" disabled />
            </el-select>
            <span v-else class="muted">取提交人部门负责人</span>
          </template>
        </el-table-column>
        <el-table-column v-if="!formReadonly" label="操作" width="70" header-align="center" align="center">
          <template slot-scope="s"><el-button type="text" size="mini" @click="removeStep(s.$index)">删除</el-button></template>
        </el-table-column>
      </el-table>
      <el-button v-if="!formReadonly" type="text" icon="el-icon-plus" @click="addStep">添加步骤</el-button>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">{{ formReadonly ? '关闭' : '取消' }}</el-button>
      <el-button v-if="!formReadonly" type="primary" :loading="actionLoading" @click="submitHandle">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '../../api/request'
import auth from './workflowAuth'
import { parseConditionJson, buildConditionJson, formatConditionText, opsForValueType } from '../../utils/workflow-condition'

const EMPTY = { valueType: 'text' }

function blank() {
  return { definitionId: '', definitionName: '', bizType: '', priority: 10, enabled: '1', conditionJson: '', remark: '', steps: [] }
}

export default {
  mixins: [auth],
  props: { bizTypeOptions: { type: Array, default: () => [] } },
  data() {
    return {
      visible: false,
      readonly: false,
      actionLoading: false,
      roleOptions: [],
      userOptions: [],
      deptOptions: [],
      conditionFieldOptions: [],
      condition: { logic: 'and', rules: [] },
      dataForm: blank(),
      dataRule: {
        definitionName: [{ required: true, message: '流程名称不能为空', trigger: 'blur' }],
        bizType: [{ required: true, message: '请选择单据类型', trigger: 'change' }]
      }
    }
  },
  computed: {
    formReadonly() { return this.readonly },
    showViewToolbar() { return this.readonly && !!this.dataForm.definitionId },
    dialogTitle() {
      if (this.readonly) return '查看审批流程'
      return this.dataForm.definitionId ? '修改审批流程' : '新增审批流程'
    },
    formRules() { return this.formReadonly ? {} : this.dataRule },
    conditionSummary() {
      return formatConditionText(this.condition, this.conditionFieldOptions, { deptOptions: this.deptOptions, userOptions: this.userOptions })
    }
  },
  methods: {
    init(id, readonly) {
      this.readonly = !!readonly
      this.dataForm = blank()
      this.condition = { logic: 'and', rules: [] }
      this.conditionFieldOptions = []
      this.loadOptions()
      this.visible = true
      this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
      if (!id) { this.addStep(); return }
      request.get('/workflow/definition/info/' + id).then(res => {
        const body = res.data || {}
        this.dataForm = Object.assign(blank(), body, {
          priority: Number(body.priority || 10),
          enabled: body.enabled == null ? '1' : String(body.enabled),
          steps: (body.steps || []).map(step => ({ ...step, approverValue: step.approverValue == null ? '' : String(step.approverValue) }))
        })
        this.loadConditionFields(this.dataForm.bizType).then(() => { this.condition = parseConditionJson(this.dataForm.conditionJson) })
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
      }).catch(() => {})
    },
    editFromView() {
      this.readonly = false
      this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
    },
    loadOptions() {
      request.get('/workflow/definition/roles').then(res => { this.roleOptions = res.data || [] }).catch(() => {})
      request.get('/workflow/definition/users').then(res => { this.userOptions = res.data || [] }).catch(() => {})
      request.get('/workflow/definition/depts').then(res => { this.deptOptions = res.data || [] }).catch(() => {})
    },
    loadConditionFields(bizType) {
      if (!bizType) { this.conditionFieldOptions = []; return Promise.resolve() }
      return request.get('/workflow/definition/conditionFields', { params: { bizType } }).then(res => {
        this.conditionFieldOptions = res.data || []
      }).catch(() => { this.conditionFieldOptions = [] })
    },
    onBizTypeChange(bizType) {
      this.condition = { logic: 'and', rules: [] }
      this.loadConditionFields(bizType)
    },
    fieldMeta(field) { return this.conditionFieldOptions.find(f => f.field === field) || EMPTY },
    opsForRow(row) { return opsForValueType(this.fieldMeta(row.field).valueType) },
    defaultValue(field, op) {
      if (op === 'in') return []
      if (this.fieldMeta(field).valueType === 'number') return undefined
      return ''
    },
    addCondition() {
      const first = this.conditionFieldOptions[0]
      if (!first) { this.$message.warning('请先在「审批条件字段」中维护该单据类型的字段'); return }
      const op = opsForValueType(first.valueType)[0].value
      this.condition.rules.push({ field: first.field, op, value: this.defaultValue(first.field, op) })
    },
    onConditionFieldChange(row) {
      const ops = this.opsForRow(row)
      row.op = ops[0] ? ops[0].value : 'eq'
      row.value = this.defaultValue(row.field, row.op)
    },
    onConditionOpChange(row) { row.value = this.defaultValue(row.field, row.op) },
    addStep() {
      this.dataForm.steps.push({ stepName: '', approverType: 'role', approverValue: '', passRule: 'single' })
    },
    removeStep(index) { this.dataForm.steps.splice(index, 1) },
    validateCondition() {
      for (let i = 0; i < this.condition.rules.length; i++) {
        const r = this.condition.rules[i]
        if (!r.field) { this.$message.error('触发条件第 ' + (i + 1) + ' 行：请选择字段'); return false }
        if (r.op === 'in') {
          if (!Array.isArray(r.value) || !r.value.length) { this.$message.error('触发条件第 ' + (i + 1) + ' 行：请选择至少一个值'); return false }
        } else if (this.fieldMeta(r.field).valueType === 'number') {
          if (r.value === undefined || r.value === null || r.value === '') { this.$message.error('触发条件第 ' + (i + 1) + ' 行：请输入数值'); return false }
        } else if (r.value === undefined || r.value === null || String(r.value).trim() === '') {
          this.$message.error('触发条件第 ' + (i + 1) + ' 行：请输入比较值'); return false
        }
      }
      return true
    },
    submitHandle() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        if (!this.dataForm.steps.length) { this.$message.error('请至少添加一个审批步骤'); return }
        if (!this.validateCondition()) return
        this.actionLoading = true
        const update = !!this.dataForm.definitionId
        const payload = Object.assign({}, this.dataForm, {
          conditionJson: buildConditionJson(this.condition),
          steps: this.dataForm.steps.map((s, i) => Object.assign({}, s, { stepNo: i + 1 }))
        })
        request.post('/workflow/definition/' + (update ? 'update' : 'save'), payload).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.actionLoading = false })
      })
    },
    deleteHandle() {
      this.$confirm('确定删除该流程定义?', '提示', { type: 'warning' }).then(() => {
        this.actionLoading = true
        request.post('/workflow/definition/delete', { definitionId: this.dataForm.definitionId }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.actionLoading = false })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
.block-title { margin: 8px 0; font-weight: 600; }
.muted { color: #909399; font-size: 12px; }
.summary { margin-bottom: 12px; color: #606266; font-size: 13px; line-height: 1.6; }
.warn { margin-left: 8px; color: #E6A23C; font-size: 12px; }
</style>
